var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstocklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 377,
    viewBox: "0 0 377 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22280_248315)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.97,
    height: 376.97,
    rx: 188.485,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.4619,
    y: -58.9014,
    width: 546.607,
    height: 532.47,
    fill: "url(#paint0_linear_22280_248315)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.057 94.2432L158.462 94.2432L117.811 94.2432L117.811 139.694L162.434 139.694L151.879 167.094C166.037 155.026 194.355 138.12 229.309 139.014L255.744 139.014L255.854 94.2432L247.35 94.2432L207.057 94.2432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.067 176.482C183.729 154.135 207.997 150.21 232.841 150.21H255.848L255.848 219.817L210.374 219.824V195.446C179.358 195.769 130.034 216.262 117.804 280.103C117.804 230.312 133.652 197.742 158.067 176.482Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.161 278.299C118.036 279.122 117.917 279.952 117.804 280.789H162.933C162.933 248.724 173.084 202.108 210.229 195.445C179.499 195.827 130.947 215.972 118.161 278.299Z",
    fill: "#96A0C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22280_248315",
    x1: 607.303,
    y1: 587.67,
    x2: 61.2521,
    y2: 43.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#11193C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4559B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22280_248315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.97,
    height: 376.97,
    rx: 188.485,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstocklogo);
export default __webpack_public_path__ + "static/media/Firstocklogo.5459963904092af18950ed7f86de01bd.svg";
export { ForwardRef as ReactComponent };